<template>
    <div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.over_stay_applications') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.over_stay_applications")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>

		<div class="content">
			<div class="container-fluid">
				<div class="card card-danger card-outline">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.search_application")}}</h3>
						<div class="card-tools">
							<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.search ? $t('label.expand') : $t('label.collapse')" @click="collapse.search = !collapse.search">
								<fa :icon="collapse.search ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
							</button>
						</div>
					</div>
					<div class="card-body">
						<table class="table table-sm table-bordered tblfind mb-0" cellspacing="0" cellpadding="0">
							<tr>
								<th width="20%">{{ $t("label.name")}}</th>
								<th width="20%">{{ $t("label.criteria")}}</th>
								<th width="30%">{{ $t("label.value_1")}}</th>
								<th width="30%">{{ $t("label.value_2")}}</th>
							</tr>
							<tr>
								<th>{{ $t("label.type")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="registration_type" v-model="registration_type.criteria" name="registration_type">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<select class="form-control" v-model="registration_type.v1" name="registration_type_v1" v-validate="'required'"  disabled>
											<option value="IM">{{$t('label.temporary_import')}}</option>
											<option value="EX">{{$t('label.temporary_export')}}</option>
										</select>
										<span class="error_smg">{{ errors.first('registration_type_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="registration_type.v2" name="registration_type_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('registration_type_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.register_date")}}</th>
								<td>
									<div class="form-group">
										<select v-model="registration_date.criteria" class="form-control" id="registration_date" name="registration_date">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="less_than">{{ $t("label.less_than")}}</option>
											<option value="less_than_or_equal">{{ $t("label.less_than_or_equal")}}</option>
											<option value="greater_than">{{ $t("label.greater_than")}}</option>
											<option value="greater_than_or_equal">{{ $t("label.greater_than_or_equal")}}</option>
											<option value="between">{{ $t("label.between")}}</option>
										</select> 
									</div>
								</td>
								<td>
									<div class="form-group">
										<datepicker :bootstrapStyling="true" :clearButton="true" :highlighted="highlightedCurrentDate" :language="lang" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="registration_date.v1" name="registration_date_v1" @input="clearRegistrationTodate">
										</datepicker>
										<input type="hidden" name="registration_date_v1" v-model="registration_date.v1" ref="registration_date_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('registration_date_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<datepicker :bootstrapStyling="true" :clearButton="true" :highlighted="highlightedCurrentDate" :language="lang" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="registration_date.v2" name="registration_date_v2" :disabledDates="{to:new Date(registration_date.v1)}">
										</datepicker>
										<input type="hidden" name="registration_date_v2" v-model="registration_date.v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('registration_date_v2') }}</span>										
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.register_number")}}</th>
								<td>
									<div class="form-group">
										<select v-model="registration_number.criteria" class="form-control" id="registration_number" name="registration_number">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="less_than">{{ $t("label.less_than")}}</option>
											<option value="less_than_or_equal">{{ $t("label.less_than_or_equal")}}</option>
											<option value="greater_than">{{ $t("label.greater_than")}}</option>
											<option value="greater_than_or_equal">{{ $t("label.greater_than_or_equal")}}</option>
											<option value="between">{{ $t("label.between")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="registration_number.v1" name="registration_number_v1" v-validate="'required|numeric'" disabled>
										<span class="error_smg">{{ errors.first('registration_number_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="registration_number.v2" name="registration_number_v2" v-validate="'required|numeric|min_value:'+registration_number.v1" disabled>
										<span class="error_smg">{{ errors.first('registration_number_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.register_year")}}</th>
								<td>
									<div class="form-group">
										<select v-model="registration_year.criteria" class="form-control" id="registration_year" name="registration_year">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="less_than">{{ $t("label.less_than")}}</option>
											<option value="less_than_or_equal">{{ $t("label.less_than_or_equal")}}</option>
											<option value="greater_than">{{ $t("label.greater_than")}}</option>
											<option value="greater_than_or_equal">{{ $t("label.greater_than_or_equal")}}</option>
											<option value="between">{{ $t("label.between")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="registration_year.v1" name="registration_year_v1" v-validate="'required|numeric|min:4|max:4'" disabled>
										<span class="error_smg">{{ errors.first('registration_year_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="registration_year.v2" name="registration_year_v2" v-validate="'required|numeric|min:4|max:4|min_value:'+registration_year.v1" disabled>
										<span class="error_smg">{{ errors.first('registration_year_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.lodgement_office_code")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" v-model="lodgement_office_code.criteria" name="lodgement_office_code">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="lodgement_office_code.v1" name="lodgement_office_code_v1"  v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('lodgement_office_code_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="lodgement_office_code.v2" name="lodgement_office_code_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('lodgement_office_code_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.lodgement_office_date")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="lodgement_office_date" v-model="lodgement_office_date.criteria" name="lodgement_office_date">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="less_than">{{ $t("label.less_than")}}</option>
											<option value="less_than_or_equal">{{ $t("label.less_than_or_equal")}}</option>
											<option value="greater_than">{{ $t("label.greater_than")}}</option>
											<option value="greater_than_or_equal">{{ $t("label.greater_than_or_equal")}}</option>
											<option value="between">{{ $t("label.between")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<datepicker :bootstrapStyling="true" :clearButton="true" :highlighted="highlightedCurrentDate" :language="lang" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="lodgement_office_date.v1" name="lodgement_office_date_v1" @input="clearLodgementToDate">
										</datepicker>
										<input type="hidden" name="lodgement_office_date_v1" v-model="lodgement_office_date.v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('lodgement_office_date_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<datepicker :bootstrapStyling="true" :clearButton="true" :highlighted="highlightedCurrentDate" :language="lang" input-class="form-control form-control-datepicker" format="dd-MM-yyyy" v-model="lodgement_office_date.v2" name="lodgement_office_date_v2" ref="lodgement_office_date_v2" :disabledDates="{to:new Date(lodgement_office_date.v1)}"> 	
										</datepicker>
										<input type="hidden" name="lodgement_office_date_v2" v-model="lodgement_office_date.v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('lodgement_office_date_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.destination_office_code")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="destination_office_code" v-model="destination_office_code.criteria" name="destination_office_code">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="destination_office_code.v1" name="destination_office_code_v1"  v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('destination_office_code_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="destination_office_code.v2" name="destination_office_code_v2" ref="destination_office_code_v2" disabled>
										<span class="error_smg">{{ errors.first('destination_office_code_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.destination_office_date")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="destination_office_date" v-model="destination_office_date.criteria" name="destination_office_date">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="less_than">{{ $t("label.less_than")}}</option>
											<option value="less_than_or_equal">{{ $t("label.less_than_or_equal")}}</option>
											<option value="greater_than">{{ $t("label.greater_than")}}</option>
											<option value="greater_than_or_equal">{{ $t("label.greater_than_or_equal")}}</option>
											<option value="between">{{ $t("label.between")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<datepicker :bootstrapStyling="true" :clearButton="true" :highlighted="highlightedCurrentDate" :language="lang" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="destination_office_date.v1" name="destination_office_date_v1" @input="clearDestinationTodate">
										</datepicker>
										<input type="hidden" name="destination_office_date_v1" v-model="destination_office_date.v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('destination_office_date_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<datepicker :bootstrapStyling="true" :clearButton="true" :highlighted="highlightedCurrentDate" :language="lang" input-class="form-control form-control-datepicker"  format="dd-MM-yyyy" v-model="destination_office_date.v2" name="destination_office_date_v2" :disabledDates="{to:new Date(destination_office_date.v1)}">
										</datepicker>
										<input type="hidden" name="destination_office_date_v2" v-model="destination_office_date.v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('destination_office_date_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.owner_border_pass")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="owner_border_pass" v-model="owner_border_pass.criteria" name="owner_border_pass">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="owner_border_pass.v1" name="owner_border_pass_v1"  v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('owner_border_pass_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="owner_border_pass.v2" name="owner_border_pass_v2"  v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('owner_border_pass_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.owner_passport")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="owner_passport" v-model="owner_passport.criteria" name="owner_passport">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="owner_passport.v1" name="owner_passport_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('owner_passport_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="owner_passport.v2" name="owner_passport_v2"  v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('owner_passport_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.company_code")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="company_code" v-model="company_code.criteria" name="company_code">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="company_code.v1" name="company_code_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('company_code_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="company_code.v2" name="company_code_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('company_code_v2') }}</span>
									</div>
								</td>
							</tr>
						</table>
					</div>
					<div class="card-footer">
						<button data-id="search" type="button" class="btn btn-sm btn-primary float-right" @click.prevent="searchApplication(1, 'registration_date', 'desc',true)"><fa :icon="fas.faSearch" class="left fa fa-circle-o nav-icon" />{{ $t('label.search') }}</button>
					</div>
				</div>

				<div class="card card-danger">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.application")}}</h3>
						<div class="card-tools">
							<button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.display ? $t('label.expand') : $t('label.collapse')" @click="collapse.display = !collapse.display">
								<fa :icon="collapse.display ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
							</button>
						</div>
					</div>
					<div class="card-body">
						<div class="table-responsive" v-if="applications.length > 0">
							<table class="table table-bordered mb-0">
								<thead>
									<tr class="cursor-pointer">
										<th nowrap></th>
										<th nowrap @click="searchApplication(1, 'lodgement_office_code', order_type, true)">{{$t('label.lodgement_office_name')}}</th>
										<th nowrap @click="searchApplication(1, 'registration_type', order_type, true)">{{$t('label.type')}}</th>
										<th nowrap @click="searchApplication(1, 'registration_date', order_type, true)">{{$t('label.register_date')}}</th>
										<th nowrap @click="searchApplication(1, 'registration_number', order_type, true)">{{$t('label.register_number')}}</th>
										<th nowrap @click="searchApplication(1, 'lodgement_office_date', order_type, true)">{{$t('label.lodgement_office_date')}}</th>
										<th nowrap @click="searchApplication(1, 'destination_office_code', order_type, true)">{{$t('label.destination_office_code')}}</th>
										<th nowrap @click="searchApplication(1, 'destination_office_date', order_type, true)">{{$t('label.destination_office_date')}}</th>
										<th nowrap @click="searchApplication(1, 'company_code', order_type, true)">{{$t('label.company_code')}}</th>
										<th nowrap style="witdh: 1%;"></th>
									</tr>
								</thead>
								<tbody  >
									<tr v-for="(app, index) in applications" :key="index" :value="app.code" :style="'color: red'">
										<td>{{(pageNumber*10-10)+index+1}}</td>
										<td>{{app.lodgement_office_code}}</td>
										<td>{{app.registration_type}}</td>
										<td>{{app.registration_date}}</td>
										<td>{{app.registration_year}} {{app.registration_serial}} {{app.registration_number}}</td>
										<td>{{app.lodgement_office_date}}</td>
										<td>{{app.destination_office_code}}</td>
										<td>{{app.destination_office_date}}</td>
										<td>{{app.company_code}}</td>
										<td nowrap style="witdh: 1%; text-align: center;">
											<router-link :to="{ name:'ViewApplication', params:{ uuid: app.uuid }}" :title="$t('label.view')" class="mr-2"><fa :icon="fas.faEye"/></router-link>
											<!-- <router-link :to="{ name:'EditApplication', params:{ uuid: app.uuid }}" :title="$t('label.edit')" class="mr-2"><fa :icon="fas.faEdit" style="color: green;"/></router-link>
											<a href="javascript: void(0)" @click="deleteApplication(app.uuid)" :title="$t('label.delete')">
												<fa :icon="fas.faTrash" style="color: red;"/>
											</a> -->
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="callout callout-success" v-else>
							<label v-if="search">{{$t('label.no_data')}}</label>
							<label v-else>{{$t('label.no_overstay')}}</label>
						</div>
					</div>
					<div class="card-footer" v-if="applications.length > 0">
						<paginate class="mb-0"
							:page-count="last_page"
							:force-page="forcepage"
							:page-range="3"
							:margin-pages="2"
							:click-handler="searchApplication"
							:container-class="'pagination float-right'"
							:prev-text="'Prev'"
							:next-text="'Next'"
							:page-class="'page-item'"
							:active-class="'active'"
							:prev-link-class="'page-link'"
							:next-link-class="'page-link'"
							:page-link-class="'page-link'"
							ref="paginate">
						</paginate>
					</div>
				</div>
			</div>
		</div>

    </div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
    name: 'Vehicles',
    data() {
        return {
                permission:{
					deleteApplication: false,
					editApplication: false,
				},
				baseURI : '',
				forcepage: 1,
				pageNumber:1,
				last_page: 0,
				registration_type:{
					criteria: "all",
					v1:'',
					v2:''
				},
				registration_serial:{
					criteria: "all",
					v1:'',
					v2:''
				},
				registration_date:{
					criteria: "all",
					v1: '',
					v2:''
				},
				registration_number:{
					criteria: "all",
					v1:'',
					v2:''
				},
				registration_year:{
					criteria: "all",
					v1:'',
					v2:''
				},
				lodgement_office_code:{
					criteria: "all",
					v1:'',
					v2:''
				},
				lodgement_office_date:{
					criteria: "all",
					v1:'',
					v2:''
				},
				destination_office_code:{
					criteria: "all",
					v1:'',
					v2:''
				},
				destination_office_date:{
					// criteria: "less_than",
					// v1: new Date(),
					criteria: "all",
					v1:'',
					v2:''
				},
				owner_border_pass:{
					criteria: "all",
					v1:'',
					v2:''
				},
				owner_passport:{
					criteria: "all",
					v1:'',
					v2:''
				},
				company_code:{
					criteria: "all",
					v1:'',
					v2:''
				},
				applications:[],
				order_by:'destination_office_date',
				order_type:'desc',
				order_type_after_sort:'',
				search: false,
				collapse:{
					search: false,
					display: false,
				}
        }
    },
    watch: {
        "registration_type.criteria" : function(val){
            if(val == "all"){
                this.registration_type.v1 = '';
                this.errors.remove('registration_type_v1');
                return this.registration_type;
            }
        },
        "registration_date.criteria" : function(val){
            if(val == "all"){
                this.registration_date.v1 = '';
                this.registration_date.v2 = '';
                this.errors.remove('registration_date_v1');
                this.errors.remove('registration_date_v2');
                return this.registration_date;
            }	
        },
        "registration_number.criteria": function(val){
            if(val == "all"){
                this.registration_number.v1 = '';
                this.registration_number.v2 = '';
                this.errors.remove('registration_number_v1');
                this.errors.remove('registration_number_v2');
                return this.registration_number;
            }	
        },
        "registration_year.criteria": function(val){
            if(val == "all"){
                this.registration_year.v1 = '';
                this.registration_year.v2 = '';
                this.errors.remove('registration_year_v1');
                this.errors.remove('registration_year_v2');
                return this.registration_year;
            }	
        },
        "lodgement_office_code.criteria": function(val){
            if(val == "all"){
                this.lodgement_office_code.v1 = '';
                this.lodgement_office_code.v2 = '';
                this.errors.remove('lodgement_office_code_v1');
                this.errors.remove('lodgement_office_code_v2');
                return this.lodgement_office_code;
            }	
        },
        "lodgement_office_date.criteria": function(val){
            if(val == "all"){
                this.lodgement_office_date.v1 = '';
                this.lodgement_office_date.v2 = '';
                this.errors.remove('lodgement_office_date_v1');
                this.errors.remove('lodgement_office_date_v2');
                return this.lodgement_office_date;
            }	
        },
        "destination_office_code.criteria": function(val){
            if(val == "all"){
                this.destination_office_code.v1 = '';
                this.destination_office_code.v2 = '';
                this.errors.remove('destination_office_code_v1');
                this.errors.remove('destination_office_code_v2');
                return this.destination_office_code;
            }	
        },
        "destination_office_date.criteria": function(val){
            if(val == "all"){
                this.destination_office_date.v1 = '';
                this.destination_office_date.v2 = '';
                this.errors.remove('destination_office_date_v1');
                this.errors.remove('destination_office_date_v2');
                return this.destination_office_date;
            }	
        },
        "owner_border_pass.criteria": function(val){
            if(val == "all"){
                this.owner_border_pass.v1 = '';
                this.owner_border_pass.v2 = '';
                this.errors.remove('owner_border_pass_v1');
                this.errors.remove('owner_border_pass_v1');
                return this.owner_border_pass;
            }	
        },
        "owner_passport.criteria": function(val){
            if(val == "all"){
                this.owner_passport.v1 = '';
                this.owner_passport.v2 = '';
                this.errors.remove('owner_passport_v1');
                this.errors.remove('owner_passport_v2');
                return this.owner_passport;
            }	
        },
        "company_code.criteria":function(val){
            if(val == "all"){
                this.company_code.v1 = '';
                this.company_code.v2 = '';
                this.errors.remove('company_code_v1');
                this.errors.remove('company_code_v2');
                return this.company_code;
            }	
        },
    },
    computed: {
        fas() {
            return fas;
        }
    },
    mounted () {
        this.APP_URL = process.env.VUE_APP_BACKEND_API_URL,
        $(".tblfind").find("select").on("change",function(){
            if($(this).val() == "all"){
                $(this).parents("tr").find("input").val("");
                $(this).parents("tr").find("input").prop("disabled",true);
                $(this).parents("tr").find("select[name='registration_type_v1']").prop("disabled", true);
                $(this).parents("tr").find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "#e9ecef");
                
                $(this).parents("tr").find("select.value").val("");
                $(this).parents("tr").find("select.value").prop("disabled",true);
            }else{
                $(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
                $(this).parents("tr").find("select[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
                // For Datepicker
                $(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("readonly");
                $(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
                $(this).find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "white");
                $(this).parents("tr").find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "white");
                if($(this).val() == "between"){
                    $(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("disabled");
                    // For Datepicker
                    $(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("readonly");
                    $(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("disabled");
                }else{
                    $(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").val("");
                    $(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").prop("disabled",true);
                    // For Datepicker
                    $(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").prop("disabled",true);
                }
            }
        });
        // $("input[name='destination_office_date_v1'").css("background-color", "white");
        $(".form-control-datepicker").prop("disabled", true);
		$("input[name='destination_office_date_v1']").prop("disabled", true);
		this.searchApplication(1, 'destination_office_date', 'desc');
    },
    methods: {
        searchApplication: function(pageNumber, order_by = null, order_type=null, searched = false) {
            this.forcepage = pageNumber;
            this.$validator.validate().then(result => {
                if (result){
                    (order_by == null ? order_by = this.order_by : order_by);
                    (order_type == null ? order_type = this.order_type_after_sort : order_type);
                    this.$store.state.loading.status = true;
                    let url = this.baseURI + 'backend/applications/overstay?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
                    GDCE_Client.requestApi("POST", url, {
                        registration_type: this.registration_type, 
                        registration_serial: this.registration_serial,
                        registration_date: this.registration_date,
                        registration_number: this.registration_number,
                        registration_year: this.registration_year,
                        lodgement_office_date: this.lodgement_office_date,
                        lodgement_office_code: this.lodgement_office_code,
                        destination_office_code: this.destination_office_code,
                        destination_office_date: this.destination_office_date,
                        owner_border_pass: this.owner_border_pass,
                        owner_passport: this.owner_passport,
                        company_code: this.company_code
                    }).then(response => {
                        this.$store.state.loading.status = false;
                        this.applications = response.data.data;
                        this.last_page = response.data.last_page;
                        this.forcepage =  response.data.current_page;
                        (order_type == 'desc' ? this.order_type = 'asc' : this.order_type='desc');
                        this.order_type_after_sort = order_type;
                        this.order_by = order_by;
                        this.permission.deleteApplication = this.$hasPermission('tempvehicle.application.delete');
                        this.permission.editApplication = this.$hasPermission('tempvehicle.application.edit');
                    });
                }
				if(searched)
					this.search = true;
                    // this.$refs.paginate.selected = 1;
            });
        },
        clearRegistrationTodate: function(data){
            this.registration_date.v2 ='';
        },
        clearLodgementToDate: function(data){
            this.lodgement_office_date.v2 ='';
        },
        clearDestinationTodate: function(data){
            this.destination_office_date.v2 ='';
        },
        getColor : function(app){
            if(app.destination && app.destination.status === 'Approve'){
                return "#cce5ff";
            }else if(app.destination && app.destination.status === 'Decline'){
                return "#f8d7da";
            }else if(app.lodgement && app.lodgement.status === 'Approve'){
                return "#d4edda";
            }else if(app.lodgement && app.lodgement.status === 'Decline'){
                return "#fff3cd";
            }else {
                return "white";
            }
        },
        deleteApplication : function(uuid){
            this.$swal({
                title: this.$t('label.confirm_delete'),
                icon: "warning",
                buttons: true,
                dangerMode: true
            }).then(willDelete => {	
                if (willDelete) {
                    let url = this.baseURI + "/backend/applications/" + uuid;
                    GDCE_Client.requestApi("DELETE", url).then(response => {
                        this.searchApplication(this.pageNumber, null, null);
                    });
                }
            });
        },
    }
}
</script>
<style scoped>
.tblfind tr td {
		padding: 0px !important;
		border-top: 0px !important;
		line-height: 30px;
	}
	.tblfind tr th {
		line-height: 30px;
	}
	.form-control{
		border-radius: 0;
	}
	.form-group{
		margin-bottom: 0;
	}
	input, select{
		margin: 0;
	}
	.error_smg{
		color:red;
	}
</style>